import { useState } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import KeunePartner from "@/components/KeunePartner";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Pricing from "@/components/Pricing";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import MailModal from "@/components/MailModal";

export default function Home() {
    const [mailOpen, setMailOpen] = useState(false);
    const openMail = () => setMailOpen(true);

    return (
        <main className="relative bg-white text-ink" data-testid="home-page">
            <Navigation />
            <Hero />
            <EditorialMarquee />
            <KeunePartner />
            <About />
            <Services />
            <Gallery />
            <Reviews />
            <Pricing />
            <Booking />
            <Contact onOpenMail={openMail} />
            <Footer />
            <FloatingButtons onOpenMail={openMail} />
            <MailModal open={mailOpen} onClose={() => setMailOpen(false)} />
        </main>
    );
}
